export const scaleHero = {
  eyebrow: '千县万村',
  title: '一个样板，不是终点',
  titleHighlight: '而是一套可以复制的模型',
  subtitle: '由帝星咖啡完成城市端验证，再由乡村场景承接复制——「0# 城市实验室 → 1# 乡村样板间」。',
  desc: '从单点验证走向千县万村，九畴云市以 E-D-A-B-C 五层组织架构，构建一张覆盖全国县域与乡村的数字商业网络。',
};

export const copySteps = [
  { code: '0#', title: '帝星数商综合体', desc: '城市验证模型', tone: 'accent' },
  { code: '1#', title: '大庄科样板', desc: '乡村复制模型', tone: 'accent' },
  { code: '10# / 100# / 1000#', title: '县域规模化复制', desc: '复制模型', tone: 'primary' },
  { code: '千县', title: '千县网络', desc: '县域网络', tone: 'primary' },
  { code: '万村', title: '万村网络', desc: '村级网络', tone: 'primary' },
  { code: '万店网络', title: '万店网络', desc: '商业网络', tone: 'primary' },
];

export const edabc = [
  { code: 'E', title: '千县云总裁', count: '1000', desc: '县域网络的组织与运营核心' },
  { code: 'D', title: '万村云掌柜', count: '10000', desc: '村级商业节点的经营主体' },
  { code: 'A', title: '十万芯青年', count: '100000', desc: '县域数字化的青年力量' },
  { code: 'B', title: '百万云创客', count: '1000000', desc: '分布式经营与创新个体' },
  { code: 'C', title: '千万车载卡 / 云农人', count: '10000000', desc: '广泛的用户与服务触达' },
];

export const nationalCopy = [
  {
    icon: 'ri-store-2-line',
    title: '云铺',
    desc: '县域数字商业的基础单元，承载数字货架与商品数字化。',
  },
  {
    icon: 'ri-store-3-line',
    title: '云店',
    desc: '实体店数字化升级，接入信用进货与数字消费。',
  },
  {
    icon: 'ri-team-line',
    title: '云社员',
    desc: '分布式经营节点，连接城乡消费场景与协同服务。',
  },
  {
    icon: 'ri-earth-line',
    title: '全国复制',
    desc: '标准化产品矩阵 + 复制模型，驱动县域规模化扩张。',
  },
];